import { useAuth } from '../contexts/AuthContext';
import { useGuild } from '../contexts/GuildContext';
import DashboardLayout from '../components/DashboardLayout';
import ServerSelector from '../components/ServerSelector';

export default function DashboardPage() {
  const { user } = useAuth();
  const { selectedGuildId, setSelectedGuildId } = useGuild();

  return (
    <DashboardLayout>
      <div className="p-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-8">
            <div>
              <h1 className="text-3xl font-bold text-gray-900 mb-2">
                대시보드
              </h1>
              <p className="text-gray-600">
                환영합니다, {user?.username}님!
              </p>
            </div>
            <div className="mt-4 md:mt-0 md:w-80">
              <ServerSelector
                selectedGuildId={selectedGuildId}
                onSelectGuild={setSelectedGuildId}
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-white rounded-lg shadow p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                서버 관리
              </h3>
              <p className="text-gray-600 text-sm">
                Discord 서버를 선택하여 규칙, 필터, 제재를 관리하세요
              </p>
            </div>

            <div className="bg-white rounded-lg shadow p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                규칙 설정
              </h3>
              <p className="text-gray-600 text-sm">
                서버 규칙과 자동 제재 단계를 설정하세요
              </p>
            </div>

            <div className="bg-white rounded-lg shadow p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                필터 관리
              </h3>
              <p className="text-gray-600 text-sm">
                스팸, 욕설 등 콘텐츠 필터를 활성화/비활성화하세요
              </p>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}
